import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchDei = createAsyncThunk(
  'reportsv2/dei',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post('/reports/team_productivity/dei', payload);
      return result?.data;
    } catch {}
  }
);

export const fetchRecruiterActivity = createAsyncThunk(
  'reportsv2/recruiterActivity',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/activity',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchFlowActivity = createAsyncThunk(
  'reportsv2/flowActivity',
  async (payload = {}, { extra: { http } }) => {
    try {
      // URL same as recruiter activity
      // differentiated by "group_by_1" in payload
      const result = await http.post(
        '/reports/team_productivity/activity',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchRepliedCandidatesByRecruiter = createAsyncThunk(
  'reportsv2/repliedCandidatesByRecruiter',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/recruiter_performance',
        payload
      );
      return result?.data;
    } catch {}
  }
);
export const fetchRepliedCandidatesByRecruiterDrillDown = createAsyncThunk(
  'reportsv2/repliedCandidatesByRecruiterDrillDown',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/recruiter_performance/drilldown',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchFlowPerformance = createAsyncThunk(
  'reportsv2/flowPerformance',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/flow_performance',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchActivityDrillDown = createAsyncThunk(
  'reportsv2/activityDrillDown',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/activity/drilldown',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchFlowPerformanceDrillDown = createAsyncThunk(
  'reportsv2/flowPerformanceDrillDown',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/flow_performance/drilldown',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchAtsOfferPerformance = createAsyncThunk(
  'reportsv2/atsOfferPerformance',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/ats_offer_performance',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchAtsOfferPerformanceDrillDown = createAsyncThunk(
  'reportsv2/atsOfferPerformanceDrillDown',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/ats_offer_performance/drilldown',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchAtsHiresPerformance = createAsyncThunk(
  'reportsv2/atsHiresPerformance',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/ats_hire_performance',
        payload
      );
      return result?.data;
    } catch {}
  }
);

export const fetchAtsHiresPerformanceDrillDown = createAsyncThunk(
  'reportsv2/atsHiresPerformanceDrillDown',
  async (payload = {}, { extra: { http } }) => {
    try {
      const result = await http.post(
        '/reports/team_productivity/ats_hire_performance/drilldown',
        payload
      );
      return result?.data;
    } catch {}
  }
);
